import { Swiper, SwiperSlide } from 'swiper/react';
import styled from 'styled-components';
import 'swiper/css';
import { useState, useEffect } from 'react'; // Import useState and useEffect
import Button from '../../../components/Button/Button';
import { ExternalLink, MoveRight } from 'lucide-react';

export default function EnterpriseSection({
  imgProps,
  title,
  type,
}: {
  imgProps: string;
  title: string;
  type: string;
}) {
  const [isMobile, setIsMobile] = useState(false); // Add isMobile state

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700); // Mobile breakpoint
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const enterpriseData = [
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Study Plus',
      description: 'Career Consultation',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Ezara Japanese Language',
      description: 'Language',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Miracle Institute Pvt. Ltd',
      description: 'Scholarships Agency',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Pokhara Expert Education',
      description: 'Academic Consultation',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Emerald Education Consultants',
      description: 'EdTech Solution Consulting',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Vito Education',
      description: 'Educational Consultancy',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'A One Global Consultants',
      description: 'Career Counseling',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Maple International Education Pvt Ltd',
      description: 'Scholarships and Career',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Shaping Minds Group',
      description: 'Career and Personality Development Counseling',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'G.Y.C.O. Consultants Pvt. Ltd',
      description: '',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'GIEC International Education Pvt. Ltd',
      description: 'Global Visa and Immigration',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Baba Education Consultancy',
      description: 'Career',
    },
    {
      imageUrl: 'https://beta.tackoom.com/wall.png',
      name: 'Silicon Education Network',
      description: 'Scholarships',
    },
  ];

  return (
    <>
      <Container>
        <ContainerBox>
          <Heading className="manrope-semibold heading-color">
            {title}.
            <a href="#" className="manrope-regular">
              {/* <u>See all</u> &nbsp; <MoveRight color="#0952B3" /> */}
            </a>
          </Heading>
        </ContainerBox>
      </Container>

      {isMobile ? (
        <VerticalStack>
          {enterpriseData.map((enterprise, index) => (
            <CounsellorCard imgProps={imgProps} key={index}>
              <div>
                <div className="img-container">
                  <img src={enterprise.imageUrl} alt="" />
                </div>
                <h6 className="manrope-bold">
                  <center>{enterprise.name}</center>
                </h6>
                <p className="manrope-regular">
                  <center>{enterprise.description}</center>
                </p>
                <div className="btn-container">
                  {type === 'profile' && (
                    <Button variant="primary">Visit organization</Button>
                  )}
                </div>
              </div>
            </CounsellorCard>
          ))}
        </VerticalStack>
      ) : (
        <Swiper
          slidesPerView={3}
          spaceBetween={1}
          breakpoints={{
            640: { slidesPerView: 4, spaceBetween: 20 },
            768: { slidesPerView: 4, spaceBetween: 20 },
            1024: { slidesPerView: 5, spaceBetween: 20 },
          }}
          className="mySwiperrr"
        >
          {enterpriseData.map((enterprise, index) => (
            <SwiperSlide key={index}>
              <CounsellorCard imgProps={imgProps}>
                <div>
                  <div className="img-container">
                    <img src={enterprise.imageUrl} alt="" />
                  </div>
                  <h6 className="manrope-bold">
                    <center>{enterprise.name}</center>
                  </h6>
                  <p className="manrope-regular">
                    <center>{enterprise.description}</center>
                  </p>
                  <div className="btn-container">
                    {type === 'profile' && (
                      <Button variant="primary">Visit organization</Button>
                    )}
                  </div>
                </div>
              </CounsellorCard>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1155px;
  padding: 2.25px;
  display: flex;
  flex-wrap: wrap;
`;

const Heading = styled.h4`
  font-size: 1.4rem;
  margin: 1.25rem 0rem;
  display: flex;
  align-items: flex-end;
  a {
    font-size: 1rem;
    margin-left: 0.25rem;
    display: flex;
    align-items: center;
  }
`;

const CounsellorCard = styled.div<{ imgProps: string }>`
  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid #d3d3d3d3;
  overflow: hidden;
  padding: 0.55rem 0.35rem;

  h6 {
    font-size: 1rem;
  }
  p {
    font-size: 0.7rem;
  }
  img {
    border-radius: ${(props) =>
      props.imgProps === 'full' ? '.45rem' : '100%'};
    width: ${(props) => (props.imgProps === 'full' ? '100%' : '8.5rem')};
    max-width: ${(props) => (props.imgProps === 'full' ? '12rem' : '8.5rem')};
    margin: ${(props) => (props.imgProps === 'full' ? '0' : '0.85rem')};
  }
  .img-container {
    display: flex;
    justify-content: center;
    span {
      position: absolute;
      display: flex;
      align-items: center;
      padding: 0 0.25rem 0 0;
      font-size: 0.65rem;
      border-radius: 0.5rem;
      border: 1px solid #c2d8b5;
      background: #dbffc6;
      color: #91af80;

      .circular-blob {
        margin: 0.25rem;
        height: 12px;
        width: 12px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #9be471;
        .inner-blob {
          height: 4px;
          width: 4px;
          border-radius: 100%;
          background-color: green;
        }
      }
    }
  }

  .btn-container {
    display: flex;
    justify-content: center;
    button {
      margin-bottom: 0;
    }
  }
`;

const VerticalStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
